































































import Vue from 'vue';

export default Vue.extend({
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      isSectionAddingLinksOpened: false,
    };
  },
});
